import * as types from "../actionTypes";
import initialState from "../../../reducers/initialState";

export const genericFilterParamReducer = (state = initialState.genericFilterParams, action) => {
  const context = action.context;
  switch (action.type) {
    case types.LOAD_GENERICFILTERPARAMS_STARTED: {
      return { ...state, [context]: { ...state[context], genericFilterParams: { loading: true, loaded: false } } };
    }
    case types.LOAD_GENERICFILTERPARAMS_SUCCEEDED: {
      return {
        ...state,
        [context]: {
          ...state[context],
          genericFilterParams: { loading: false, loaded: true, ids: [...action.result] }
        }
      };
    }
    case types.LOAD_GENERICFILTERPARAMS_FAILED: {
      return { ...state, [context]: { ...state[context], genericFilterParams: { loading: false, loaded: false } } };
    }

    default:
      return state;
  }
};
